cobalt-breadcrumb {
  display: flex;
}

.core-breadcrumb-list {
  margin: 0;
  padding: 0;
}

.core-breadcrumb-list cobalt-link {
  display: flex;
  align-items: center;
  color: var(--color-neutral-content-medium);
}
